import { axiosPrivate } from "./customAxios";

const SYNC_CONFIRMED_WEBHOOK_URL =
  "https://n8n.aqviser.com/webhook/sync-confirmed";
const FB_SYNC_CONFIRMED_WEBHOOK_URL =
  "https://n8n.aqviser.com/webhook/fb-sync-confirmed";

class SocialActions {
  async addSocialId(socialId: string, platform: string): Promise<void> {
    const response = await axiosPrivate.post(
      `/social/social-id/add?socialId=${socialId}&platform=${platform}`
    );
    return response.data;
  }

  /** Notify n8n that WhatsApp sync is confirmed (fire-and-forget). */
  notifySyncConfirmed(wa_id: string): void {
    fetch(SYNC_CONFIRMED_WEBHOOK_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ wa_id })
    }).catch(() => {});
  }

  /** Notify n8n that Facebook Messenger sync is confirmed (fire-and-forget). */
  notifyFbSyncConfirmed(user_id: string): void {
    fetch(FB_SYNC_CONFIRMED_WEBHOOK_URL, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ user_id })
    }).catch(() => {});
  }

  /** Call the appropriate sync-confirmed webhook for the given platform. */
  notifySyncConfirmedForPlatform(socialId: string, platform: string): void {
    const isFb = /facebook|messenger|fb/i.test(platform);
    if (isFb) {
      this.notifyFbSyncConfirmed(socialId);
    } else {
      this.notifySyncConfirmed(socialId);
    }
  }
}

export const socialActions = new SocialActions();
